import * as React from 'react';

interface SubscriptionDetails {
  plan: string;
  endDate: string;
  accessUntil: string;
}

interface SubscriptionCancellationEmailProps {
  name?: string;
  company?: string;
  supportEmail?: string;
  domain?: string;
  subscription?: SubscriptionDetails;
  reactivateLink?: string;
  feedbackLink?: string;
}

export const SubscriptionCancellationEmail: React.FC<SubscriptionCancellationEmailProps> = ({
  name = 'João Silva',
  company = 'Trivium',
  supportEmail = 'suporte@trivium.com.br',
  domain = 'trivium.com.br',
  subscription = {
    plan: 'Plano Premium',
    endDate: '15/08/2023',
    accessUntil: '31/08/2023'
  },
  reactivateLink = 'https://trivium.com.br/minha-conta/reativar',
  feedbackLink = 'https://trivium.com.br/feedback/cancelamento',
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Logo%20Trivium%20Rebranded%20Branco%20150%20dpi-0VfiiO2tOZNdZlvY5A7z3saYZGysgq.png" 
          alt="Trivium"
          style={logoImageStyle}
        />
      </div>
      
      {/* Content */}
      <div style={contentStyle}>
        <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ backgroundColor: '#FFE7E7' }}>
          <tr>
            <td align="center" style={{ padding: '40px 20px' }}>
              <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ maxWidth: '400px' }}>
                {/* Círculo com ícone */}
                <tr>
                  <td align="center" style={{ paddingBottom: '30px' }}>
                    <div style={{ 
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '50%', 
                      backgroundColor: '#1F1746', 
                      display: 'inline-block',
                      textAlign: 'center',
                      lineHeight: '60px'
                    }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" fill="white"/>
                      </svg>
                    </div>
                  </td>
                </tr>
                
                {/* Título */}
                <tr>
                  <td align="center" style={{ paddingBottom: '15px' }}>
                    <h1 style={{ 
                      margin: '0',
                      fontSize: '28px',
                      color: '#333333',
                      fontWeight: '600'
                    }}>
                      Assinatura Cancelada
                    </h1>
                  </td>
                </tr>
                
                {/* Mensagem */}
                <tr>
                  <td align="center" style={{ paddingBottom: '25px' }}>
                    <p style={{ 
                      margin: '0',
                      fontSize: '16px',
                      color: '#666666'
                    }}>
                      Sua solicitação de cancelamento foi processada
                    </p>
                  </td>
                </tr>
                
                {/* Badge */}
                <tr>
                  <td align="center">
                    <div style={{ 
                      backgroundColor: '#FF5252',
                      borderRadius: '24px',
                      color: '#FFFFFF',
                      fontWeight: '600',
                      fontSize: '15px',
                      padding: '12px 25px',
                      display: 'inline-block'
                    }}>
                      Cancelado
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Olá, {name}!</h2>
          
          <p style={paragraphStyle}>
            Estamos enviando este e-mail para confirmar que sua assinatura do {subscription.plan} foi cancelada 
            conforme solicitado. Lamentamos ver você partir e esperamos que tenha tido uma boa experiência 
            com os nossos serviços.
          </p>
        </div>
        
        <div style={courseCardStyle}>
          <div style={courseHeaderStyle}>
            <h3 style={courseTitleStyle}>Detalhes do Cancelamento</h3>
          </div>
          
          <div style={courseDetailsStyle}>
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data de cancelamento:</div>
                <div style={detailValueStyle}>{subscription.endDate}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Acesso disponível até:</div>
                <div style={detailValueStyle}>{subscription.accessUntil}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Plano cancelado:</div>
                <div style={detailValueStyle}>{subscription.plan}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div style={nextStepsStyle}>
          <h3 style={nextStepsTitleStyle}>O que acontece agora?</h3>
          <p style={paragraphStyle}>
            Você continuará tendo acesso a todos os recursos do seu plano até <strong>{subscription.accessUntil}</strong>. 
            Após essa data, sua conta será convertida para o plano gratuito com recursos limitados.
          </p>
          <p style={paragraphStyle}>
            Se você mudar de ideia, você pode reativar sua assinatura a qualquer momento antes 
            da data de término do acesso, sem perder seus dados ou configurações.
          </p>
          <div style={buttonContainerStyle}>
            <a href={reactivateLink} style={buttonStyle}>
              Reativar Minha Assinatura
            </a>
          </div>
        </div>
        
        <div style={feedbackStyle}>
          <h3 style={feedbackTitleStyle}>Sua opinião é importante</h3>
          <p style={paragraphStyle}>
            Gostaríamos de entender melhor os motivos do seu cancelamento para que possamos 
            melhorar nossos serviços. Por favor, considere responder a uma breve pesquisa de feedback.
          </p>
          <div style={buttonContainerStyle}>
            <a href={feedbackLink} style={secondaryButtonStyle}>
              Compartilhar Feedback
            </a>
          </div>
        </div>
        
        <hr style={hrStyle} />
        
        <div style={footerContentStyle}>
          <p style={footerStyle}>
            Se você tiver alguma dúvida sobre seu cancelamento, entre em contato conosco:
          </p>
          <div style={contactChannelsStyle}>
            <p style={contactChannelStyle}>✉️ {supportEmail}&nbsp;&nbsp;📱 (11) 3181-5940</p>
          </div>
          <p style={footerStyle}>
            Esperamos vê-lo novamente em breve!<br />
            Equipe {company}
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <div style={emailFooterStyle}>
        <p style={copyrightStyle}>
          © 2025 {company}. Todos os direitos reservados.
        </p>
        <div style={footerLinksStyle}>
          <a href={`https://${domain}/termos`} style={footerLinkStyle}>Termos de Uso</a>
          <span style={footerDividerStyle}>|</span>
          <a href={`https://${domain}/privacidade`} style={footerLinkStyle}>Política de Privacidade</a>
        </div>
      </div>
    </div>
  );
};

// Estilos
const brandColor = '#1F1746';
const accentColor = '#3E5FBA';
const backgroundColor = '#F5F7FA';
const textColor = '#333333';
const secondaryTextColor = '#666666';

const containerStyle = {
  fontFamily: "'Satoshi', Arial, sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: backgroundColor,
};

const headerStyle = {
  backgroundColor: brandColor,
  padding: '25px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

const logoImageStyle = {
  maxWidth: '180px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const contentStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '0 0 8px 8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
  padding: '0',
  margin: '0 0 20px 0',
  overflow: 'hidden',
};

const contentContainerStyle = {
  padding: '0 40px',
};

const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: brandColor,
  marginBottom: '16px',
  padding: '24px 0 0 0',
};

const paragraphStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: textColor,
  margin: '16px 0',
  padding: '0 40px',
};

const courseCardStyle = {
  border: '1px solid #E1E4E8',
  borderRadius: '8px',
  overflow: 'hidden',
  margin: '24px 40px',
};

const courseHeaderStyle = {
  backgroundColor: brandColor,
  padding: '16px 24px',
};

const courseTitleStyle = {
  margin: '0',
  color: '#ffffff',
  fontSize: '18px',
  fontWeight: '600',
};

const courseDetailsStyle = {
  padding: '20px 24px',
  backgroundColor: '#ffffff',
};

const detailBlockStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '16px',
};

const detailIconContainerStyle = {
  width: '24px',
  marginRight: '12px',
  paddingTop: '2px',
};

const detailLabelStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  fontWeight: '500',
  marginBottom: '4px',
};

const detailValueStyle = {
  fontSize: '15px',
  color: textColor,
  fontWeight: '500',
};

const nextStepsStyle = {
  padding: '8px 0 24px 0',
};

const nextStepsTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 16px 0',
  padding: '0 40px',
};

const feedbackStyle = {
  padding: '0 0 24px 0',
  backgroundColor: '#F8F9FA',
  margin: '0 40px 24px 40px',
  borderRadius: '8px',
  paddingTop: '24px',
};

const feedbackTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 16px 0',
  padding: '0 40px',
};

const buttonContainerStyle = {
  textAlign: 'center' as const,
  margin: '24px 0',
};

const buttonStyle = {
  backgroundColor: brandColor,
  borderRadius: '6px',
  color: '#fff',
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
};

const secondaryButtonStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '6px',
  color: brandColor,
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '11px 23px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
  border: `1px solid ${brandColor}`,
};

const hrStyle = {
  borderColor: '#E1E4E8',
  margin: '24px 40px',
};

const footerContentStyle = {
  padding: '0 40px 32px 40px',
};

const footerStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const contactChannelsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '8px',
};

const contactChannelStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '6px 0',
  fontWeight: '500',
};

const emailFooterStyle = {
  backgroundColor: backgroundColor,
  padding: '24px 40px',
  textAlign: 'center' as const,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
};

const copyrightStyle = {
  fontSize: '13px',
  color: secondaryTextColor,
  margin: '0 0 12px 0',
};

const footerLinksStyle = {
  margin: '8px 0',
};

const footerLinkStyle = {
  color: brandColor,
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: '500',
};

const footerDividerStyle = {
  color: secondaryTextColor,
  margin: '0 8px',
};

export default SubscriptionCancellationEmail; 